/**
 * Sticky submit bar. "Post rating only" needs a rating; "Post review" needs the basics
 * (what you ordered + the dish to get). Disabled buttons explain why via title/aria.
 */
interface SubmitBarProps {
  canPostRating: boolean;
  canPostReview: boolean;
  busy: boolean;
  onPostRating: () => void;
  onPostReview: () => void;
}

export function SubmitBar({ canPostRating, canPostReview, busy, onPostRating, onPostReview }: SubmitBarProps) {
  return (
    <div className="submit-bar">
      <button
        type="button"
        className="btn btn-secondary"
        disabled={!canPostRating || busy}
        title={canPostRating ? 'Post just your rating' : 'Pick a Three Rivers rating first'}
        onClick={onPostRating}
      >
        Post rating only
      </button>
      <button
        type="button"
        className="btn btn-primary"
        disabled={!canPostReview || busy}
        title={canPostReview ? 'Write and post the full review' : 'Add what you ordered and the dish to get'}
        onClick={onPostReview}
      >
        {busy ? 'Posting…' : 'Post review'}
      </button>
    </div>
  );
}
